module.exports = __webpack_public_path__ + "img/shop.6631751a.png";